<div class="rev-grid">
  <div>
    <div class="tabs" role="tablist">
      <button type="button" class="tab" role="tab" *ngFor="let t of tabs; trackBy: trackByKey" [attr.aria-selected]="df.tab === t.key" [attr.data-tab]="t.key" (click)="setTab(t.key)">
        {{ t.label }}<span class="c">{{ t.count }}</span>
      </button>
    </div>

    <div class="hint decided" *ngIf="doneCount" style="margin:8px 0;display:flex;align-items:center;gap:10px">
      <b>{{ doneCount }} decided</b> · {{ leftCount }} left in this view<span class="sp" style="flex:1"></span>
      <button type="button" class="btn sm ghost show-decided" (click)="showDecided()">Show decided again</button>
    </div>

    <div class="banner" *ngIf="pendingCount">
      <df-icon name="help" [size]="18"></df-icon>
      <div><b>{{ pendingCount }} need your call.</b> Mark each relevant or irrelevant.</div>
    </div>

    <div class="toolbar">
      <div class="search-in">
        <df-icon name="search" [size]="14"></df-icon>
        <input class="filter-q" [(ngModel)]="df.filters.q" placeholder="Filter by name or code" aria-label="Filter by name or code">
      </div>
      <select [(ngModel)]="df.filters.l2" aria-label="L2 process">
        <option value="all">All L2 processes</option>
        <option *ngFor="let x of l2" [value]="x.id">{{ x.id }}</option>
      </select>
      <select [(ngModel)]="df.filters.land" aria-label="Landscape">
        <option value="all">As-Is and To-Be</option><option value="asis">As-Is only</option><option value="tobe">To-Be only</option>
      </select>
      <select [(ngModel)]="df.filters.src" aria-label="Source">
        <option value="all">All sources</option>
        <option *ngFor="let k of sourceKeys" [value]="k">{{ sourceShort(k) }}</option>
      </select>
      <span class="sp"></span>
      <label class="hint" for="df-sort">Sort</label>
      <select id="df-sort" [(ngModel)]="df.sort">
        <option value="conf">Relevance</option><option value="name">Name</option><option value="date">Last modified</option>
      </select>
    </div>

    <div class="bulkbar" role="region" aria-label="Bulk actions" *ngIf="df.selection.size">
      <b>{{ df.selection.size }} selected</b><span class="sp"></span>
      <button type="button" class="btn sm bulk-inc" (click)="bulkInclude()"><df-icon name="check" [size]="13"></df-icon>Mark relevant</button>
      <button type="button" class="btn sm bulk-exc" (click)="bulkExclude()"><df-icon name="x" [size]="13"></df-icon>Mark irrelevant</button>
      <button type="button" class="btn sm bulk-clear" (click)="clearSelection()">Clear</button>
    </div>

    <ng-container *ngIf="groups.length; else noResults">
      <section class="card group" *ngFor="let g of groups; trackBy: trackByType" [attr.data-group]="g.type">
        <div class="group-h">
          <input type="checkbox" [checked]="g.allSelected" (change)="selectGroup(g.type, $any($event.target).checked)" [attr.aria-label]="'Select all ' + docTypes[g.type].short">
          <span class="bar" [style.background]="docTypes[g.type].color"></span>
          <div>
            <h3>{{ docTypes[g.type].long }}</h3>
            <div class="gsub">
              {{ df.tab === 'x' ? 'Excluded by the agent, each with its reason. Mark any relevant to overrule it.' : g.type === 'other' ? 'The agent found these but could not place them as an Explore input' : 'I found ' + g.docs.length + ' · ' + g.included + ' marked relevant' }}
            </div>
          </div>
          <span class="sp"></span>
          <button type="button" class="btn sm ghost mark-all" (click)="markAll(g.type)">Mark all relevant</button>
        </div>
        <df-doc-row *ngFor="let d of g.docs; trackBy: trackById" [doc]="d"></df-doc-row>
      </section>
    </ng-container>
    <ng-template #noResults>
      <div class="card empty">No documents match these filters. <button type="button" class="link clear-filters" (click)="clearFilters()">Clear filters</button></div>
    </ng-template>
  </div>

  <df-coverage-rail></df-coverage-rail>
</div>
